// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30cVx","input":"styles_input__3I6nR"};